import React from 'react';

import { SVGComponentProps } from './svg.types';

const MembersSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M5.99967 1.3335C4.25301 1.3335 2.83301 2.7535 2.83301 4.50016C2.83301 6.2135 4.17301 7.60016 5.91967 7.66016C5.97301 7.6535 6.02634 7.6535 6.06634 7.66016C6.07968 7.66016 6.08634 7.66016 6.09967 7.66016C6.10634 7.66016 6.10634 7.66016 6.11301 7.66016C7.81967 7.60016 9.15968 6.2135 9.16634 4.50016C9.16634 2.7535 7.74634 1.3335 5.99967 1.3335Z"
          fill={fill}
        />
        <path
          d="M9.38664 9.43342C7.52664 8.19342 4.49331 8.19342 2.61997 9.43342C1.77331 10.0001 1.30664 10.7668 1.30664 11.5868C1.30664 12.4068 1.77331 13.1668 2.61331 13.7268C3.54664 14.3534 4.77331 14.6668 5.99997 14.6668C7.22664 14.6668 8.45331 14.3534 9.38664 13.7268C10.2266 13.1601 10.6933 12.4001 10.6933 11.5734C10.6866 10.7534 10.2266 9.99342 9.38664 9.43342Z"
          fill={fill}
        />
        <path
          d="M13.3263 4.89356C13.4329 6.1869 12.5129 7.32023 11.2396 7.47356C11.2329 7.47356 11.2329 7.47356 11.2263 7.47356H11.2062C11.1662 7.47356 11.1262 7.47356 11.0929 7.4869C10.4462 7.52023 9.85292 7.31356 9.40625 6.93356C10.0929 6.32023 10.4863 5.40023 10.4062 4.40023C10.3596 3.86023 10.1729 3.3669 9.89292 2.9469C10.1463 2.82023 10.4396 2.74023 10.7396 2.71356C12.0463 2.60023 13.2129 3.57356 13.3263 4.89356Z"
          fill={fill}
        />
        <path
          d="M14.6605 11.0599C14.6071 11.7066 14.1938 12.2666 13.5005 12.6466C12.8338 13.0133 11.9938 13.1866 11.1605 13.1666C11.6405 12.7333 11.9205 12.1933 11.9738 11.6199C12.0405 10.7933 11.6471 9.99994 10.8605 9.36661C10.4138 9.01327 9.89382 8.73327 9.32715 8.52661C10.8005 8.09994 12.6538 8.38661 13.7938 9.30661C14.4071 9.79994 14.7205 10.4199 14.6605 11.0599Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default MembersSVG;
